import React, { useState } from "react";
import { Routes, Route, useLocation, Navigate, Link } from "react-router-dom";
import { Menu, Button } from "antd";
import { ReloadOutlined } from "@ant-design/icons";
import SalesUnpaid from "./sales-unpaid";
import SalesActive from "./sales-active";
import SalesUsed from "./sales-used";
import "./sales.css";
import { useCompany } from "@redux";

const Sales = () => {
  const location = useLocation();
  const company = useCompany();
  const [unpaidLoading, setUnpaidLoading] = useState(false);
  const [activeLoading, setActiveLoading] = useState(false);
  const [unpaidRefreshKey, setUnpaidRefreshKey] = useState(0);
  const [activeRefreshKey, setActiveRefreshKey] = useState(0);
  const currentPath = location.pathname;
  const isActiveTab = currentPath === "/sales/active";
  const refreshLoading = isActiveTab ? activeLoading : unpaidLoading;
  const backgroundStyle = company?.catalogBackgroundImage
    ? { backgroundImage: `url("${company.catalogBackgroundImage}")` }
    : undefined;

  const items = [
    { key: "/sales", label: <Link to="/sales">Корзина</Link> },
    { key: "/sales/active", label: <Link to="/sales/active">Покупки</Link> },
    // { key: "/sales/used", label: <Link to="/sales/used">Использованные</Link> },
  ];

  return (
    <div className="sales-container" style={backgroundStyle}>
      <div className="sales-sub-menu-wrapper">
        <Menu mode="horizontal" selectedKeys={[currentPath]} items={items} className="sales-sub-menu" />
        <Button
          className="sales-refresh-button"
          icon={<ReloadOutlined />}
          onClick={() => isActiveTab ? setActiveRefreshKey((key) => key + 1) : setUnpaidRefreshKey((key) => key + 1)}
          loading={refreshLoading}
          size="middle"
        >
          <span className="sales-refresh-text">Обновить</span>
        </Button>
      </div>
      <Routes>
        <Route index element={<SalesUnpaid refreshKey={unpaidRefreshKey} onLoadingChange={setUnpaidLoading} />} />
        <Route path="active" element={<SalesActive refreshKey={activeRefreshKey} onLoadingChange={setActiveLoading} />} />
        <Route path="used" element={<SalesUsed />} />
        <Route path="*" element={<Navigate to="/sales" replace />} />
      </Routes>
    </div>
  );
};

export default Sales;
